import React from 'react';
import './uploadConfig.scss';
import { DATA_CONFIGURATION } from '../../Constants/strings';
import LeaveUploadConfig from './LeaveUpload/configLeaveUpload';
import EffortUploadConfig from './EffortUpload/configEffortUpload';

const DataConfig = () => {
  return (
    <div className="data-conf-outer-layer">
      <div className="data-config ">
        <h1 className="data-config-title">{DATA_CONFIGURATION.TITLES_TEXT}</h1>
        <div className="config-data-grid-container">
          <EffortUploadConfig />
          <LeaveUploadConfig />
        </div>
      </div>
    </div>
  );
};

export default DataConfig;
